import React from 'react';

const Skills = () => (
  <section id="skills">
    <div className="wrap">
      <div className="eyebrow">
        <span className="prompt">$</span> cat skills.json
      </div>
      <h2 className="section-title">Tools &amp; stack</h2>
      <p className="section-sub">
        What I reach for, organized by what it's for rather than how long I've used it.
      </p>

      <div className="skills-grid reveal-stagger">
        <div className="skill-card">
          <span className="skill-cat">Languages</span>
          <div className="skill-tags">
            <span>JavaScript</span>
            <span>TypeScript</span>
            <span>C#</span>
            <span>PHP</span>
            <span>HTML/CSS</span>
          </div>
        </div>
        <div className="skill-card">
          <span className="skill-cat">Frameworks</span>
          <div className="skill-tags">
            <span>Node.js</span>
            <span>NestJS</span>
            <span>React</span>
            <span>React Native</span>
            <span>ASP.NET Core</span>
          </div>
        </div>
        <div className="skill-card">
          <span className="skill-cat">Databases</span>
          <div className="skill-tags">
            <span>PostgreSQL</span>
            <span>MongoDB</span>
            <span>MySQL</span>
          </div>
        </div>
        <div className="skill-card">
          <span className="skill-cat">Deploy &amp; Cloud</span>
          <div className="skill-tags">
            <span>Docker</span>
            <span>Vercel</span>
            <span>Render</span>
            <span>Azure</span>
            <span>DigitalOcean</span>
            <span>CI/CD</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Skills;
